export default {
  title: 'POS Configurations',
  page_title: 'POS Configurations | Thanx',
  banner_message:
    'Menu errors are grouped by menu, not by location. Since most menus are shared across many locations, fix once in your menu configuration, and it resolves everywhere that menu is used.',
  provider: {
    toast: 'Toast',
    olo: 'Olo',
  },
  provider_tabs: {
    aria_label: 'Switch between provider error views',
    olo_tab_title: 'Olo locations have per-location errors',
    olo_tab_description:
      'Olo menus aren’t shared across locations, so menu-grouped errors don’t apply. Open the Locations page to see each Olo location’s error list.',
    olo_tab_cta: 'View Locations',
  },
  severity: {
    error: 'Error',
    notice: 'Notice',
  },
  badge: {
    errors: 'errors',
    notices: 'notices',
  },
  used_in_locations: 'Used in %{count} locations',
  view_locations: 'View locations',
  view_support: 'View what Thanx supports',
  loading: 'Loading menu errors…',
  empty_title: 'No menu errors to show yet',
  empty_description:
    'Menu-level error grouping is in development. When your ordering provider reports errors, this page will list them grouped by menu so you can fix once and resolve everywhere that menu is used.',
  empty_olo_title: 'Menu-grouped errors are not available for Olo merchants',
  empty_olo_description:
    'Olo menus are configured per location and do not share a single source of truth. View ordering errors on the Locations page.',
  empty_olo_cta: 'View Locations',
  empty_provider_skip_title:
    'Menu monitoring isn’t available for %{provider} yet',
  empty_provider_skip_description:
    'We haven’t built menu-error monitoring for this provider yet. Check back soon.',
  empty_healthy_title: 'All menus are healthy',
  empty_healthy_description: 'Nothing to fix here right now.',
  empty_error_title: 'Couldn’t load menu errors',
  empty_error_description:
    'Something went wrong fetching menu errors. Refresh the page to try again.',
  menu_errors_list: {
    aria_label: 'Menu errors',
    // react-i18nify pluralization picks `<key>_plural` when `count !== 1`
    // and falls back to the base `<key>` for the singular case, so each
    // pluralisable string is a (base, _plural) pair rather than the
    // i18next-style `_one`/`_other` suffixes used in some other locale
    // files (those don't pluralize correctly with this library).
    badge: {
      errors: '%{count} error',
      errors_plural: '%{count} errors',
      notices: '%{count} notice',
      notices_plural: '%{count} notices',
      healthy: 'Healthy',
    },
    card_healthy: 'No errors or notices for this menu.',
    used_in_locations: 'Used in %{count} location',
    used_in_locations_plural: 'Used in %{count} locations',
    view_locations: 'View locations',
    view_locations_aria: 'View locations for %{menuName}',
    show_errors_aria: 'Show errors for %{menuName}',
    hide_errors_aria: 'Hide errors for %{menuName}',
    show_card_aria: 'Show menu status for %{menuName}',
    hide_card_aria: 'Hide menu status for %{menuName}',
    card_loading: 'Loading errors…',
    card_error: 'Couldn’t load errors for this menu. Try refreshing.',
    severity_label: {
      error: 'Error',
      notice: 'Notice',
    },
    // Severity leads the accessible name because the button's aria-label
    // overrides the descendant severity icon's label — without it a
    // screen-reader user can't tell an Error row from a Notice row.
    expand_row_aria: 'Show %{severity} details for %{message}',
    collapse_row_aria: 'Hide %{severity} details for %{message}',
    no_items: 'No specific items reported for this error yet.',
    copy_item_id_aria: 'Copy item ID for %{name}',
    item_id_copied: 'Copied item ID for %{name}',
    item_id_copy_failed: 'Couldn’t copy item ID. Try again.',
  },
  locations_modal: {
    aria_label: 'Locations using %{menuName}',
    title: 'Enabled locations',
    loading: 'Loading locations…',
    subtitle: '%{count} location',
    subtitle_plural: '%{count} locations',
    column_location: 'Location',
    empty: 'No locations are linked to this menu.',
    error: 'Couldn’t load locations. Try refreshing.',
    pagination_status: 'Showing locations %{start} to %{end} of %{total}',
    close: 'Close',
  },
  help: {
    title: 'Help',
    enable_disable: 'How to enable and disable locations',
    troubleshoot_menu_errors: 'How to troubleshoot menu errors',
  },
}
